import { render, staticRenderFns } from "./CommercialClaimList.vue?vue&type=template&id=4a1a898f&"
import script from "./CommercialClaimList.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimList.vue?vue&type=script&lang=js&"
import style0 from "./CommercialClaimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports